<template>
  <form :action="'https://talk.naver.com/' + naverTalkId" target="_self" method="post" ref="form">
    <input type="hidden" name="chatRoomId" v-model="chatRoomId" />
  </form>
</template>

<script>
export default {
  name: 'naverChatOpen',
  props: {
    naverTalkId: {
      type: String,
      default: null
    },
    chatRoomId: {
      type: String,
      default: null
    }
  },
  mounted() {
    window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
    this.$refs.form.submit();
  }
};
</script>
